export default __webpack_public_path__ + "static/media/03.5def2903.jpg";